import { createAsyncThunk } from "@reduxjs/toolkit";
import fetchAPI, { gutendexAPI  } from "../../utils/axios";
import { getGutenbergEndPointByAgeGroup, getEndpointBySearchQuery } from "../../utils/Constants";

export const getListOfBooksByAgeGroup = createAsyncThunk(
    "bookSelection/getByAge",
    async ({ ageGroup, sortBy, page, pageSize }, thunkApi ) => {
        try {
            const endpoint = getGutenbergEndPointByAgeGroup(ageGroup, sortBy, page, pageSize);
            console.log(`BookByAge Endpoint: ${endpoint}`);
            const { data } = await gutendexAPI.get(endpoint);
            return data;
        } catch (error) {
            return thunkApi.rejectWithValue(error.message);
        }
    }
);

export const searchBooksByQuery = createAsyncThunk(
    "bookSelection/search",
    async ({ query, page, pageSize }, thunkApi) => {
        try {
            const endpoint = getEndpointBySearchQuery(query, page, pageSize);
            console.log(`Search endpoint: ${endpoint}`);
            const { data } = await gutendexAPI.get(endpoint);
            return data;
        } catch(error) {
            return thunkApi.rejectWithValue(error.message);
        }
    }
)

export const getBookById = createAsyncThunk(
  'bookSelection/getById',
  async (bookId, thunkApi) => {
    try {
      const { data: bookMetadata } = await gutendexAPI.get(`/books/${bookId}`);

      // Find available format (text/html or text/plain)
      const formats = bookMetadata.formats || {};
      const gutenUrl = formats["text/html"];

      let paragraphText = "";

      if (gutenUrl) {
        try {
          const { data: textRes } = await fetchAPI.get('/gutenberg/fetchText', {
            params: { url: gutenUrl }
          });
          paragraphText = textRes?.data?.text || "";
        } catch (fetchErr) {
          console.error('Error fetching text content:', fetchErr);
        }
      }

      return {
        ...bookMetadata,
        paragraphText
      };
    } catch (err) {
      return thunkApi.rejectWithValue(err.message);
    }
  }
);